import React, { Fragment } from 'react';
import classnames from 'classnames';

import { Svg } from 'src/components/Svg/Svg';
import { SvgIconNames } from 'src/components/Svg/icons-types';

export type TabItem = {
    content: React.ReactNode;
    icon?: string;
    id: string;
    title: string;
};

export type MobileTabsProps = {
    borderStyles?: React.CSSProperties;
    isPageBuilder?: boolean;
    layoutStyles?: React.CSSProperties;
    tabs: TabItem[];
    openIndexes: number[];
    handleTabClick: (index: number) => void;
};

export function MobileTabs(props: MobileTabsProps) {
    return (
        <section className="tabs">
            {props.tabs.map((item, index) => {
                const active = props.openIndexes.includes(index);
                return (
                    <Fragment key={`tab-${item.id}`}>
                        <button
                            type="button"
                            className="tabs__item"
                            data-ui-active={active}
                            aria-haspopup="menu"
                            aria-expanded={active}
                            aria-controls={`${item.id}-panel`}
                            onClick={() => props.handleTabClick(index)}
                            style={props.borderStyles}
                        >
                            <span className="tabs__title">
                                {item.icon && <Svg name={item.icon as SvgIconNames} />} {item.title}
                            </span>
                            <Svg name="arrow-down" />
                        </button>
                        <div
                            style={props.borderStyles}
                            className={classnames('tabs__body', { tabs__body__pagebuilder: props.isPageBuilder })}
                            data-ui-active={active}
                            id={`${item.id}-panel`}
                            aria-labelledby={`tab-${item.id}`}
                            role="region"
                        >
                            {item.content}
                        </div>
                    </Fragment>
                );
            })}
        </section>
    );
}
